import React, { Component } from 'react';
import { Button, Grid, Header, Segment, Icon, Card } from 'semantic-ui-react';

class Reviews extends Component {
  render() {
    return (
      <Segment style={{ padding: '8em 0em' }} vertical>
        <Grid container stackable>
          <Grid.Row>
            <Grid.Column width={14}>
               <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}> BeemaFam testimonials. </Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row width={16} style={{padding:'3em 0em'}} centered>
              <Grid.Column width={5}>
                <Card style={{backgroundColor: '#FFB805'}}>
                  <Card.Content>
                    <Card.Header>Samuel W.</Card.Header>
                    <Card.Meta>
                      <span className='date'>Founder, The Goods LA</span>
                    </Card.Meta>
                    <Card.Description>
                      I was recommended to Beema by a friend who has already used their services
                      to attain insurance. I really enjoy working with them because they are young
                      and they understand startups. They were patient and walked me through every
                      detail of my business insurance. They were also very upfront about pricing
                      and it was just a really easy process. I love it!
                    </Card.Description>
                  </Card.Content>
                  <Card.Content extra>
                    <Icon name='star' />
                    <Icon name='star' />
                    <Icon name='star' />
                    <Icon name='star' />
                    <Icon name='star' />
                  </Card.Content>
                </Card>
              </Grid.Column>

              <Grid.Column width={5}>
                <Card style={{backgroundColor: '#FFB805'}}>
                  <Card.Content>
                    <Card.Header>Joesph F.</Card.Header>
                    <Card.Meta>
                      <span className='date'>Founder, In The Cloud IT</span>
                    </Card.Meta>
                    <Card.Description>
                      Starting a new business is hard especially when you are a one man band.
                      One of the most difficult things that many new businesses struggle with
                      is insurance and coverage. I know that I myself didn't even know where to
                      start! Then I came across Beemabroker and their talented team! From the
                      start they helped me navigate the confusing market of policies and helped
                      me pick the right coverage for my business at the right price... read more
                    </Card.Description>
                  </Card.Content>
                  <Card.Content extra>
                    <Icon name='star' />
                    <Icon name='star' />
                    <Icon name='star' />
                    <Icon name='star' />
                    <Icon name='star' />
                  </Card.Content>
                </Card>
              </Grid.Column>

              <Grid.Column width={5}>
                <Card style={{backgroundColor: '#FFB805'}}>
                  <Card.Content>
                    <Card.Header>Liane T.</Card.Header>
                    <Card.Meta>
                      <span className='date'>CEO, Aquaai</span>
                    </Card.Meta>
                    <Card.Description>
                      I read about BeemaBroker while researching insurance options.
                      Not knowing much about the industry, I needed a lot of information
                      explained and they were patient. I love that they really care!!
                      They are also really easy to work with, have great pricing (and yes
                      I looked into other options), and they are very very efficient. Huge fan!
                    </Card.Description>
                  </Card.Content>
                  <Card.Content extra>
                    <Icon name='star' />
                    <Icon name='star' />
                    <Icon name='star' />
                    <Icon name='star' />
                    <Icon name='star' />
                  </Card.Content>
                </Card>
              </Grid.Column>


          </Grid.Row>

          <Grid.Row centered>
            <a href='https://www.facebook.com/pg/BeemaBroker/reviews/'>
              <Button color='facebook'>
              <Icon name='facebook' /> Read More Reviews
              </Button>
            </a>
            <a href='/home#request-acesss'>
              <Button color='teal'>
              Join Private Beta
              </Button>
            </a>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
};

export default Reviews;



// WEBPACK FOOTER //
// ./src/js/Home/Reviews.js